import { useEffect } from 'react'

type ClickAwayProps = {
  isOpened: boolean
  ref: any
  callback: () => void
}

export function useOnClickAway(props: ClickAwayProps) {
  const handleClickOutside = (e: MouseEvent | TouchEvent) => {
    if (
      props.ref?.current &&
      !props.ref?.current?.contains(e.target as HTMLElement) &&
      e.isTrusted
    ) {
      props.callback()
    }
  }

  useEffect(() => {
    if (props.isOpened) {
      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('touchstart', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)
    }
  }, [props.isOpened])
}
